//SiteWide Notification cookie

function setCookie(cname,cvalue,exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires=" + d.toGMTString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";

}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

var header = document.getElementById('header');

//Check Notification Cookie
function checkNotificationCookie() {
  var notification = getCookie("notification-banner");
  var acceptCookies = document.getElementById("notificationBanner");

  if (notification == '') {
    acceptCookies.classList.add("open");
    header.classList.add('notification-open');
  } else {
    console.log('no banner');
    // acceptCookies.classList.add("visible");
  }
}

//Check Cookie Cookie
function checkCookie() {
  var cookie = getCookie("cookieBanner");
  var cookieBanner = document.getElementById("cookieBanner");

  if (cookie == '') {
    cookieBanner.classList.add("open");
    header.classList.add('cookie-open');
  } else {
    // acceptCookies.classList.add("visible");
  }
}

var notificationEl = document.getElementById("notificationBanner");
var cookieEl = document.getElementById("cookieBanner");
var header = document.getElementById('header');
var closeButton = document.getElementById("closeNotification");
var closeCookie = document.getElementById('closeCookie');
var acceptCookies = document.getElementById('acceptCookies');

closeButton.addEventListener('click', function(){
  notificationEl.classList.remove('open');
  header.classList.remove('notification-open');
}, false);

// closeCookie.addEventListener('click', function(){
//   cookieEl.classList.remove('open');
// }, false);

// acceptCookies.addEventListener('click', function(){
//   cookieEl.classList.remove('open');
// }, false);

document.addEventListener("DOMContentLoaded", function(event) {   
  checkNotificationCookie();
  // checkCookie();
});